import * as React from 'react';
import { GetStaticProps } from 'next';

import EmployerGettingStartedPage from '../components/organisations/autonomous-create-organization';
import { getServerTranslations } from '../get-server-side-translations';

const GettingStartedPage: React.FunctionComponent = () => <EmployerGettingStartedPage />;

export default GettingStartedPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const translation = await getServerTranslations(locale, ['common', 'restaurant-onboarding']);
  return {
    props: {
      ...translation,
    },
  };
};
